webpackJsonp([70144966829960],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(9);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = (0, _reactI18next.translate)('contact')(function (_ref) {
	  var t = _ref.t;
	  return _react2.default.createElement(
	    'div',
	    { id: 'contact' },
	    _react2.default.createElement(_Header2.default, { current: 'contact' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col1 col-pad1' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          'Contact'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col3' },
	        _react2.default.createElement(
	          'form',
	          { name: 'contact', action: '/thanks/', method: 'POST', 'data-netlify': 'true' },
	          _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'name' },
	            'Name'
	          ),
	          _react2.default.createElement('input', { type: 'text', id: 'name', name: 'name' }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'email' },
	            'Mail'
	          ),
	          _react2.default.createElement('input', { type: 'email', id: 'email', name: 'email' }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'category' },
	            'Category'
	          ),
	          _react2.default.createElement(
	            'select',
	            { name: 'category', id: 'category' },
	            _react2.default.createElement(
	              'option',
	              { value: 'pr' },
	              t('pr')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'hr' },
	              t('hr')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'bz' },
	              t('bz')
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'ot' },
	              t('ot')
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'message' },
	            'Message'
	          ),
	          _react2.default.createElement('textarea', { id: 'message', name: 'message' }),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-primary col1' },
	            'Send'
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{ name: 'description', content: 'Babels Contact' }, { property: 'og:title', content: 'Babels Contact' }, { property: 'og:url', content: 'https://babels.co/contact' }, { property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff' }, { property: 'og:image:width', content: '600' }, { property: 'og:image:height', content: '400' }, { property: 'og:description', content: 'Babels Contact' }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@null' }, { name: 'twitter:creator', content: '@null' }]
	    }),
	    _react2.default.createElement(Contact, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-1d855c5a0c0f40639136.js